import { EntityMetadataModel, EntityPropertyMetadataModel } from '../../../../api/api';
import { ExpressionModel } from '../../Models/ExpressionModel';
import { ObjectExpressionModel } from '../../Models/ObjectExpressionModel';
import { createObjectMapExpression } from './mapExpressionHelpers';

export function getObjectExpression(
	expression: ObjectExpressionModel | undefined,
	property: EntityPropertyMetadataModel,
	propertyExpression: ExpressionModel | undefined,
	expectedObjectType: EntityMetadataModel,
): ObjectExpressionModel {
	// Start with existing properties, but remove any case-insensitive matches of the property being updated
	const existingProperties = { ...expression?.Properties };

	// Remove any existing property that matches the property name (case-insensitive)
	const propertyNameLower = property.name.toLowerCase();
	Object.keys(existingProperties).forEach((key) => {
		if (key.toLowerCase() === propertyNameLower) {
			delete existingProperties[key];
		}
	});

	// Add the new property value with the correct casing from the schema
	const updatedProperties = { ...existingProperties, [property.name]: propertyExpression };

	// Build a map of lowercase names to actual schema property names for casing normalization
	const schemaPropertyMap = new Map(expectedObjectType.properties.map((p) => [p.name.toLowerCase(), p.name]));

	// Filter to only include properties that exist in expectedObjectType and normalize to schema casing
	const finalProperties: Record<string, ExpressionModel> = {};
	for (const [key, value] of Object.entries(updatedProperties)) {
		if (value === undefined) continue;

		const schemaPropertyName = schemaPropertyMap.get(key.toLowerCase());
		if (schemaPropertyName) {
			// Use the schema's casing and ensure no duplicates (last one wins)
			finalProperties[schemaPropertyName] = value;
		}
	}

	return createObjectMapExpression(finalProperties, expression?.MapIf);
}
